import { useResetCrudSelectionOnUnmount } from '@/atoms'

import { useDriversRoot } from './useDriversRoot'
import { DriversList } from './DriversList'
import { DriverForm } from './DriverForm/DriverForm'
import { BulkDriverView } from './BulkDriverView/BulkDriverView'
import { BulkDriverForm } from './BulkDriverForm/BulkDriverForm'
import { DriverView } from './DriverView/DriverView'

export function DriversRoot() {
  const { editing, drivers, selectedDrivers, selection } = useDriversRoot()
  const bulk = selectedDrivers.length > 1
  const single = selectedDrivers.length === 1

  const driver = selectedDrivers[0]

  useResetCrudSelectionOnUnmount('drivers')

  return (
    <>
      <DriversList editing={editing} drivers={drivers} selection={selection} />
      {bulk && !editing && <BulkDriverView drivers={selectedDrivers} />}
      {bulk && editing && <BulkDriverForm drivers={selectedDrivers} />}
      {editing && !bulk && <DriverForm driver={driver} />}
      {single && !editing && driver && <DriverView driver={driver} />}
    </>
  )
}
